import { render, staticRenderFns } from "./SwitchCustomer.vue?vue&type=template&id=390cdb84&"
import script from "./SwitchCustomer.vue?vue&type=script&lang=ts&"
export * from "./SwitchCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports